/**
 * Typography Style Guide
 * ref : https://app.zeplin.io/project/5af28128b796c6cb8430dfb0/screen/5af2830c2ac357844c378aa9
 */
import { StyleSheet } from 'react-native';
import { K_WEIGHT_BOLD } from '@dkrm/general-libs/theme/styles';
import { fontFamily } from '@dkrm/general-libs/theme/fonts';
export const tStyles = {
  h1: {
    fontFamily,
    fontSize: 33,
    lineHeight: 40,
    fontWeight: K_WEIGHT_BOLD
  },
  h2: {
    fontFamily,
    fontSize: 25,
    lineHeight: 32,
    fontWeight: K_WEIGHT_BOLD
  },
  h3: {
    fontFamily,
    fontSize: 21,
    lineHeight: 28,
    fontWeight: K_WEIGHT_BOLD
  },
  h4: {
    fontFamily,
    fontSize: 18,
    lineHeight: 24,
    fontWeight: K_WEIGHT_BOLD
  },
  h5: {
    fontFamily,
    fontSize: 15,
    lineHeight: 20,
    fontWeight: K_WEIGHT_BOLD
  },
  h6: {
    fontFamily,
    fontSize: 12,
    lineHeight: 16,
    letterSpacing: 0.1,
    fontWeight: K_WEIGHT_BOLD
  },
  h7: {
    fontFamily,
    fontSize: 10,
    lineHeight: 12,
    letterSpacing: 0.2,
    fontWeight: K_WEIGHT_BOLD
  },
  body1: {
    fontFamily,
    fontSize: 21,
    lineHeight: 28
  },
  body2: {
    fontFamily,
    fontSize: 17,
    lineHeight: 24
  },
  body3: {
    fontFamily,
    fontSize: 15,
    lineHeight: 20
  },
  body4: {
    fontFamily,
    fontSize: 12,
    lineHeight: 16,
    letterSpacing: 0.1
  },
  body5: {
    fontFamily,
    fontSize: 11,
    lineHeight: 14,
    letterSpacing: 0.1
  },
  body6: {
    fontFamily,
    fontSize: 8,
    lineHeight: 12,
    letterSpacing: 0.15
  },
  caption1: {
    fontFamily,
    fontSize: 15,
    lineHeight: 20
  },
  caption2: {
    fontFamily,
    fontSize: 12,
    lineHeight: 16
  },
  caption3: {
    fontFamily,
    fontSize: 10,
    lineHeight: 12,
    letterSpacing: 0.2
  }
};
export default StyleSheet.create(tStyles);